import {useEffect, useState} from 'react'
import {Message, useToaster} from 'rsuite'
import type {TypeAttributes} from 'rsuite/esm/internals/types'
import type {PlacementType} from 'rsuite/esm/toaster/ToastContainer'

/**
 * Toast React component settings.
 */
export interface ToastSettings {
  /**
   * The message.
   */
  message: string
  /**
   * The title.
   */
  title?: string
  /**
   * The type of message.
   */
  type?: TypeAttributes.Status
  /**
   * The placement.
   */
  placement?: PlacementType
}

/**
 * Creates the function for changing {@link ToastSettings} settings.
 * @returns the function for setting the {@link ToastSettings} settings.
 */
export const useShowMessage = () => {
  const [settings, setSettings] = useState<ToastSettings>()
  const toaster = useToaster()

  useEffect(() => {
    if (!settings) return
    const placement = settings.placement || 'bottomEnd'
    const type = settings.type || 'info'
    toaster.push(<Message type={type} title={settings.title}>{settings.message}</Message>, {
      placement: placement
    })
    setSettings(undefined)
  }, [settings, toaster])
  return setSettings
}
